import AdminList from "./AdminList";

export default function Drivers() {
  return <AdminList type="drivers" />;
}
